import { Link } from 'react-router-dom';
import useImageUrl from 'hooks/useImageUrl';
import routeNames from 'router/routeNames.json';
import { PriceTag } from './common/PriceTag';
import { productTypes } from 'constants';

export default function HomeLastChanceTee({ tee, imageLink }) {
  const activeType = tee.types[0];
  const constructImageUrl = useImageUrl();

  return (
    <div className="mb-4 md:mb-0 w-1/3">
      <Link to={imageLink}>
        <img
          src={constructImageUrl({
            img: tee.zoom,
            width: 380,
            height: 465,
          })}
          alt={activeType?.name}
          width={`${380}px`}
          height={`${465}px`}
        />
      </Link>

      <footer className="flex justify-between bg-gray-200 text-white w-full">
        <div className="p-1 text-gray-900 leading-tight font-sans flex-1 flex flex-col truncate">
          <span className="font-bold hover:text-black truncate">
            {tee.name}
          </span>
          <span className="truncate">
            by{' '}
            <Link
              className="font-bold text-qw-blue-500 hover:text-qw-green"
              to={`${routeNames.profile}/${tee.user?.id}`}
            >
              {tee.user?.username}
            </Link>
          </span>
        </div>
        <PriceTag
          className="h-auto"
          price={activeType?.price}
          size="medium"
          type={productTypes.tees}
        />
      </footer>
    </div>
  );
}
